import { render, staticRenderFns } from "./importModal.vue?vue&type=template&id=198c38fe&"
import script from "./importModal.vue?vue&type=script&lang=ts&"
export * from "./importModal.vue?vue&type=script&lang=ts&"
import style0 from "./importModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports